import WsProvider from './provider/WSProvider'


var base64 = require('base64_js');
var serviceName = "iletisim";
var iletisimService = {
    iletisimDetay(iletisimId) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                iletisimId: iletisimId,
                methodName: "iletisimDetay"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    iletisimArsiv(iletisimId) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                iletisimId: iletisimId,
                methodName: "iletisimArsiv"

            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    iletisimList(durum, baslangic, limit) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                konuKodu: "",
                durum: durum,
                baslangic: baslangic,
                limit: limit,
                methodName: "iletisimList"

            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
};
export default iletisimService

